import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice
const name = "user-register";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const userRegisterAction = { ...slice.actions, ...extraActions };
export const userRegisterReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    signUpResponse: {},
    loading: false,
    committeesList: [],
    userProfileCommitteesList: [],
    otpResponse: {},
    clearOTPResponse: {},
    verifyLoginOTPResponse: {},
    resendOTPResponse: {},
  };
}

function createReducers() {
  return {
    clearOTPResponse,
  };

  function clearOTPResponse(state) {
    state.otpResponse = {};
    state.signUpResponse = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;
  return {
    signUp: signUp(), //register+
    getCommitteesList: getCommitteesList(),
    getCommitteesListforUserProfile: getCommitteesListforUserProfile(),
    verifyOTP: verifyOTP(),
    verifyLoginOTP: verifyLoginOTP(),
    resendLoginOTP: resendLoginOTP(),
    clearOTP: clearOTP(),
    updateMemberCommitteeList: updateMemberCommitteeList(),
  };

  function signUp() {
    return createAsyncThunk(
      `${name}/register`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/users/register`, data),
    );
  }

  // Get Committees List
  function getCommitteesList() {
    return createAsyncThunk(`${name}/labels`, async () => {
      return await fetchWrapper.get(`${baseUrl}/committee/labels/register`);
    });
  }

  // Get Committee List for User Profile
  function getCommitteesListforUserProfile() {
    return createAsyncThunk(`${name}/userProfile`, async () => {
      return await fetchWrapper.get(`${baseUrl}/committee/labels/userProfile`);
    });
  }

  function verifyOTP() {
    return createAsyncThunk(
      `${name}/verifyOtp`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/users/verifyOtp`, data),
    );
  }

  function verifyLoginOTP() {
    return createAsyncThunk(
      `${name}/verifyLoginOTP`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/users/loginVerifyOtp`, data),
    );
  }

  function resendLoginOTP() {
    return createAsyncThunk(
      `${name}/resendLoginOTP`,
      async (email) =>
        await fetchWrapper.post(`${baseUrl}/users/resendLoginOTP`, email),
    );
  }
  function clearOTP() {
    return createAsyncThunk(
      `${name}/clearOTP`,
      async (email) =>
        await fetchWrapper.post(`${baseUrl}/users/clearOTP`, email),
    );
  }

  function updateMemberCommitteeList() {
    return createAsyncThunk(
      `${name}/updateMemberCommitteeList`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/users/addOrLeaveCommittee`, data),
    );
  }
}

function createExtraReducers(builder) {
  builder

    .addCase(extraActions.signUp.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.signUp.fulfilled, (state, action) => {
      state.loading = false;
      state.signUpResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.signUp.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to register";
    })

    // Get Committees List
    .addCase(extraActions.getCommitteesList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCommitteesList.fulfilled, (state, action) => {
      state.loading = false;
      state.committeesList = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.getCommitteesList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    })

    // Get Committees List for User Profile
    .addCase(extraActions.getCommitteesListforUserProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getCommitteesListforUserProfile.fulfilled,
      (state, action) => {
        state.loading = false;
        state.userProfileCommitteesList = action?.payload;
        state.error = null;
      },
    )
    .addCase(
      extraActions.getCommitteesListforUserProfile.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to get committees";
      },
    )

    // VerifyOTP
    .addCase(extraActions.verifyOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.verifyOTP.fulfilled, (state, action) => {
      state.loading = false;
      state.otpResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.verifyOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    })

    // Verify Login OTP
    .addCase(extraActions.verifyLoginOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.verifyLoginOTP.fulfilled, (state, action) => {
      state.loading = false;
      state.verifyLoginOTPResponse = action?.payload;
      const user = action.payload;
      sessionStorage.setItem("isLoggedIn", true);
      sessionStorage.setItem("userRoleID", user?.data?.user?.role);
      sessionStorage.setItem(
        "loggedUserName",
        user?.data?.user?.firstName + " " + user?.data?.user?.lastName,
      );
      sessionStorage.setItem(
        "committee_Id",
        JSON.stringify([
          ...user?.data?.user?.committees,
          ...user?.data?.user?.committeesAdmin,
        ]),
      );
      state.error = null;
    })
    .addCase(extraActions.verifyLoginOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    })
    // resend Login OTP
    .addCase(extraActions.resendLoginOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.resendLoginOTP.fulfilled, (state, action) => {
      state.loading = false;
      state.resendOTPResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.resendLoginOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    })
    // clear OTP
    .addCase(extraActions.clearOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.clearOTP.fulfilled, (state, action) => {
      state.loading = false;
      state.clearOTPResponse = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.clearOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to remove OTP";
    })

    //update Member Committee List
    .addCase(extraActions.updateMemberCommitteeList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.updateMemberCommitteeList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateMemberCommitteeListResponse = action?.payload;
        state.error = null;
      },
    )
    .addCase(
      extraActions.updateMemberCommitteeList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to get committees";
      },
    );
}
